// @flow
import styled, { injectGlobal } from 'styled-components';
import Textarea from 'react-textarea-autosize';
import theme from '../../styles/theme';

export const ComposeWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: block;
  position: relative;
  padding: 15px 0px;
  vertical-align: top;
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
`;

export const TitleInput = styled(Textarea)`
  font-size: 20px;
  font-family: ${props => props.theme.fontBold};
  font-weight: bold;
  border: none;
  padding: 8px 0;
  flex: 1;
  vertical-align: top;
  display: inline-block;
  border-radius: 2px;
  width: calc(100% - 170px);
  margin-right: 20px;
  resize: none;
  &:focus {
    outline: none;
  }
`;

injectGlobal`
  .md-side-toolbar {
    display: flex;
  }
  .md-sb-button.md-sb-img-button {
    font-size: 14px;
    &:hover, &:focus, &:active {
      color: ${theme.colors.green};
      border-color: ${theme.colors.green};
    }
  }
  .DraftEditor-root {
    .md-block-image-inner-container {
      text-align: center;
    }
    img {
      max-height: 300px;
    }
  }
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 0px;
  > * {
    flex: 1;
  }
`;

export const DisqusWrapper = styled.div`
  padding: 0 0px;
`;



// WEBPACK FOOTER //
// ./src/pages/proposal/proposal.styles.js